var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Consultation = require('Consultation');
var Labels = EY.Consultation.Labels;
var Logger = require('Logger');
var Lookups = EY.Consultation.Lookups;
var filtered = {};

var filter = function () {
    try {
        var user = EY.Consultation.CurrentUser;

        filtered = Lookups.RedBoxCountryApi;
        if (user.location.country) {
            var country = _.findWhere(EY.Consultation.Resources.Countries, { text: user.location.country });
            var geography = new RegExp((country ? country.id : '') + '|' + user.geography);

            Logger.log('-RedBox- Filter - Before:', filtered);
            filtered = _.pick(filtered, function (api, redbox) {
                return geography.test(redbox);
            });
            Logger.log('-RedBox- Filter - After:', filtered);
        }
        _.extend(filtered, { '//': Lookups.API.Consultation });
    } catch (ex) {
        Logger.log('Error filtering redbox apis.', ex);
    }
};

var extend = function (options) {
    if (options.aggregate) {
        delete options.aggregate;
        options.aggregate = _.clone(options.aggregateWithoutZone);
        if (options.aggregate[0] && options.aggregate[0].$match) {
            options.aggregate[0] = {
                $match: {
                    $and: [options.aggregate[0].$match, {
                        $or: [{
                            zoneKey: options.zone
                        }]
                    }]
                }
            };
        }
    } else if (options.filter) {
        delete options.filter;
        options.filter = _.clone(options.filterWithoutZone);
        options.filter = {
            $and: [{
                zoneKey: options.zone
            }, options.filter]
        };
    }
};

// configureV2 has the following changes with regards to configure:
// - Unlike configure, configureV2 is able to fetch and return records even if one or more apis are down.
// - Simplifies the optimization mechanism
// - Simplifies the dependency between optimize flag sent from Home.js and this function by introducing isFirstRun
// - Shows a message whenever one or more apis are down.
var configureV2 = function () {
    var Entities = require('Entities');
    var apis = _.extend({ '//': Lookups.API.Consultation }, Lookups.RedBoxCountryApi);
    var optimize = Lookups.Configuration.OptimizeRedboxApiFetch;
    var isFirstRun = true;  //This flag is used to filter apis where the count returned was 0. Such apis are not called subsequently.
    
    Entities.Records = Entities.Records.extend({
        sync: function (method, collection, options) {
            var deferred = $.Deferred();
            var promise = '';
            options.aggregateWithoutZone = _.clone(options.aggregate);
            options.filterWithoutZone = _.clone(options.filter);
            
            if (method === 'read') {
                var count = !_.isEmpty(options.aggregate) && /"\$count": ?"count"/.test(JSON.stringify(options.aggregate));
                var pageCount = 0;
                var records = [];
                var total = 0;
                var apiFetches = [];    //Used to keep promises for each API call
                var apisToCall = [];    //Unique APIs to call
                var apisWithResults = [];   //This array is used to keep APIs for which a non-zero count was returned.
                var currentAPI;
                
                promise = deferred.promise();
                _.chain(filtered).values().uniq().map(function (api) {

                    if (EY.Consultation.RetryFailedZone) {
                        extend(_.extend(options, { zone: +(Lookups.RedBoxCountryZoneApi[api] || 0) }));
                    }

                    //Store all unique APIs to call
                    apisToCall.push(api);
                    apiFetches.push(_.extend(new Backbone.Collection(), { url: api + 'Record' }).fetch(_.extend(options, { silent: true })));
                });

                Promise.allSettled(apiFetches).then(function(fetchResponse) 
                {   
                    fetchResponse.forEach(function(result, index) {

                        //Get the current API for which response is being processed.
                        currentAPI = apisToCall[index];
                            
                        if(result.status === "fulfilled") {
                            var items = result.value;

                            if (count) {

                                //Get count of records found
                                var apiCount = (items.length ? _.first(items).count : 0);

                                pageCount = apiCount > pageCount ? apiCount : pageCount;
                                total = total + apiCount;

                                //If optimize is true and it's running for first time:
                                //Find APIs that returned a non-zero value and store them.
                                optimize && isFirstRun 
                                    && !!apiCount 
                                    && apisWithResults.push(currentAPI);
                                
                                optimize && Logger.log('-Redbox- [' + apiCount + '/' + total + ' (' + pageCount + ')]|api:' + currentAPI + (options.debugging ? '|query:' + options.debugging : ''));

                            } else {

                                records = records.concat(items);
                            }
                        }
                    });
                }).then(function () {

                    var response = count ? [{ count: total, pageCount: pageCount }] : records;
                    
                    if (optimize && isFirstRun) {

                        Logger.log('-Redbox- Optimization - Before:', filtered);
                        
                        // Remove APIs which didn't get any results.
                        // This ensures that for any subsequent fetches these APIs are not invoked.
                        filtered = _.chain(filtered).pick(function (value) {
                            
                            return _.indexOf(apisWithResults, value) > -1;
                        }).value();

                        Logger.log('-Redbox- Optimization - After:', filtered);

                    }
                    isFirstRun = false;
                    
                    collection.reset(response);
                    collection.trigger('sync');
                    collection.trigger('synced');
                    deferred.resolve(response);
                });

                //Retry
                promise.fail(function () {

                    if (!EY.Consultation.RetryFailedZone) {
                        EY.Consultation.RetryFailedZone = true;
                        require('Home').start();
                    }
                });
            }
            return promise || Backbone.sync.apply(this, arguments);
        }
    });

    Entities.User = Entities.User.extend({
        sync: function (method, model, options) {
            var upn = EY.Consultation.CurrentUser ? EY.Consultation.CurrentUser.upn : '';

            if (method === 'create' || method === 'update') {
                if (!options.silent) {
                    _.chain(apis).values().uniq().each(function (api) {
                        if (method === 'update') {
                            model.set({
                                modifiedBy: upn,
                                modifiedOn: new Date()
                            });
                        }
                        if (method === 'create') {
                            model.set({
                                createdBy: upn,
                                createdOn: new Date()
                            });
                        }

                        var user = new Entities.User(model.attributes);

                        user.urlRoot = api + 'User';
                        if (user.urlRoot !== model.urlRoot) {
                            user.save({}, { silent: true });
                        }
                    }).value();
                }
            }
            return Backbone.sync.apply(this, arguments);
        }
    });
};

var configure = function () {
    var Entities = require('Entities');
    var apis = _.extend({ '//': Lookups.API.Consultation }, Lookups.RedBoxCountryApi);
    var apisCount = {};
    var optimize = Lookups.Configuration.OptimizeRedboxApiFetch;

    Entities.Records = Entities.Records.extend({
        sync: function (method, collection, options) {
            var deferred = $.Deferred();
            var promise = '';
            options.aggregateWithoutZone = _.clone(options.aggregate);
            options.filterWithoutZone = _.clone(options.filter);

            if (method === 'read') {
                var count = !_.isEmpty(options.aggregate) && /"\$count": ?"count"/.test(JSON.stringify(options.aggregate));
                var pageCount = 0;
                var records = [];
                var total = 0;

                promise = deferred.promise();
                $.when.apply(this, _.chain(filtered).values().uniq().map(function (api) {
                    if (EY.Consultation.RetryFailedZone) {
                        extend(_.extend(options, { zone: +(Lookups.RedBoxCountryZoneApi[api] || 0) }));
                    }
                    return _.extend(new Backbone.Collection(), { url: api + 'Record' }).fetch(_.extend(options, { silent: true })).done(function (items) {
                        if (count) {
                            var apiCount = (items.length ? _.first(items).count : 0);

                            pageCount = apiCount > pageCount ? apiCount : pageCount;
                            total = total + apiCount;
                            if (optimize) {
                                if (options.optimize) {
                                    apisCount[api] = (apisCount[api] || 0) + apiCount;
                                } else if (!_.isEmpty(apisCount)) {
                                    Logger.log('-Redbox- Optimization - Before:', filtered);
                                    filtered = _.chain(filtered).pick(function (value) {
                                        return apisCount[value];
                                    }).value();
                                    apisCount = {};
                                    Logger.log('-Redbox- Optimization - After:', filtered);
                                }
                                Logger.log('-Redbox- [' + apiCount + '/' + total + ' (' + pageCount + ')]|api:' + api + (options.debugging ? '|query:' + options.debugging : ''));
                            }
                        } else {
                            records = records.concat(items);
                        }
                    }).fail(function () {
                        if (!EY.Consultation.RetryFailedZone) {
                            deferred.reject();
                        }
                    });

                }).value()).then(function () {
                    var response = count ? [{ count: total, pageCount: pageCount }] : records;

                    collection.reset(response);
                    collection.trigger('sync');
                    collection.trigger('synced');
                    deferred.resolve(response);
                });

                //Retry
                promise.fail(function () {

                    if (!EY.Consultation.RetryFailedZone) {
                        EY.Consultation.RetryFailedZone = true;
                        require('Home').start();
                    }
                });
            }
            return promise || Backbone.sync.apply(this, arguments);
        }
    });

    Entities.User = Entities.User.extend({
        sync: function (method, model, options) {
            var upn = EY.Consultation.CurrentUser ? EY.Consultation.CurrentUser.upn : '';

            if (method === 'create' || method === 'update') {
                if (!options.silent) {
                    _.chain(apis).values().uniq().each(function (api) {
                        if (method === 'update') {
                            model.set({
                                modifiedBy: upn,
                                modifiedOn: new Date()
                            });
                        }
                        if (method === 'create') {
                            model.set({
                                createdBy: upn,
                                createdOn: new Date()
                            });
                        }

                        var user = new Entities.User(model.attributes);

                        user.urlRoot = api + 'User';
                        if (user.urlRoot !== model.urlRoot) {
                            user.save({}, { silent: true });
                        }
                    }).value();
                }
            }
            return Backbone.sync.apply(this, arguments);
        }
    });
};

module.exports.configure = function (options) {
    var reset = (options || {}).reset;

    filter();
    if (!reset) {
        Lookups.Configuration.UseRedboxConfigureV2 == 'true' ? configureV2() : configure();
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Service/Redbox.js